import androidWebViewApi from './androidWebViewApi'
import getEnv from './getEnv'

export const isLowSpec = () => {
    return (
        getEnv('IS_LOW_SPEC') ||
        androidWebViewApi.isRunInAndroidWebView() ||
        document.URL.indexOf('lowspec') >= 0
    )
}
